import { useDispatch, useSelector } from "react-redux";
import Container from "react-bootstrap/Container";
import ProgressBar from "react-bootstrap/ProgressBar";
import { resetQuiz } from "../store-app/slices/InterviewSlice";
import { quizMap } from "../utils/quizMap";

function Result({type}) {
  const { quizData, marks } = useSelector((state) => state.quiz);
  const dispatch = useDispatch();

 const handleReset = () => {
    if (type && quizMap[type]) {
      dispatch(resetQuiz(quizMap[type]));
    }
  };

  const totalMarks = quizData.length * 5;
  const scorePercent = (marks / totalMarks) * 100;

  let feedback = "";
  let bgColor = "";

  if (scorePercent >= 80) {
    feedback = "Excellent!";
    bgColor = "bg-success";
  } else if (scorePercent >= 50) {
    feedback = "Good Job!";
    bgColor = "bg-warning";
  } else {
    feedback = "Oops!";
    bgColor = "bg-danger";
  }

  return (
    <section className="bg-dark text-white min-vh-100 d-flex align-items-center">
      <Container className="text-center">
        <div className={`p-5 rounded ${bgColor} animate__animated animate__fadeIn`}>
          <h1 className="mb-3 fw-bold">{feedback}</h1>
          <h3 className="mb-4">
            Your score: {marks} / {totalMarks}
          </h3>

          <ProgressBar
            now={scorePercent}
            label={`${Math.round(scorePercent)}%`}
            variant={
              scorePercent >= 80
                ? "success"
                : scorePercent >= 50
                ? "warning"
                : "danger"
            }
            className="mb-4"
          />

          <button
            onClick={handleReset}
            className="btn btn-light fw-bold px-4 py-2"
          >
            Start Again
          </button>
        </div>
      </Container>
    </section>
  );
}

export default Result;
